export const initialAbilities = [
  {
    action: 'READ',
    subject: 'AUTH',
  },
]

export const _ = undefined
